import { render } from "./our-pick-badge.vue?vue&type=template&id=12afb6a6&scoped=true"
import script from "./our-pick-badge.vue?vue&type=script&lang=js"
export * from "./our-pick-badge.vue?vue&type=script&lang=js"

import "./our-pick-badge.vue?vue&type=style&index=0&id=12afb6a6&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12afb6a6"]])

export default __exports__